'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // this element must be present on all pages, where datalayer pushes are executed 
    var customerInfoElement = document.getElementById('customerInfoElement');
    if (!customerInfoElement) return;

    // prevent performing multiple pushes in one second
    if (preventMultiplePushes()) return;

    var customerReference = customerInfoElement.value;
    var pushMode = customerInfoElement.dataset.pushMode;
    // every load push customer details
    pushPageLoadCustomer();

    // presence of this elements leads to continue in this functionality
    var orderSuccessInput = document.getElementById('orderSuccessInput');
    if (!orderSuccessInput) {
        return;
    }
    var pushedOrdersKey = 'pushedOrders';
    var pushedOrders = (_storageProvider2.default.getValueSession(pushedOrdersKey, 1000) || '').split('|');

    try {
        var orderDataObject = JSON.parse(orderSuccessInput.value);
        processOrder(orderDataObject.CommissionOrder);
        processOrder(orderDataObject.InvoiceOrder);
    } catch (e) {
        console.error('Error pushing values to Google analytics. It is probably problem in serializing orderSuccessInput value.');
    }

    function preventMultiplePushes() {
        var multipleGaPushKeeperKey = 'multipleGaPushKeeper';
        var nowSec = Math.floor(new Date().getTime() / 1000);
        var multipleGaPushKeeper = parseInt(_storageProvider2.default.getValueSession(multipleGaPushKeeperKey, 1) || '0');
        if (multipleGaPushKeeper === nowSec) {
            return true;
        }
        _storageProvider2.default.setValueSession(multipleGaPushKeeperKey, nowSec);
        return false;
    }

    function pushPageLoadCustomer() {
        try {
            var dataObject = {
                event: 'page_load',
                customer: customerReference,
                customerId: customerInfoElement.dataset.customerId,
                timestampUnixMs: new Date().getTime()
            };
            // push
            if ((pushMode & 1) > 0) window.dataLayer.push(dataObject);
            // log
            if ((pushMode & 2) > 0) console.debug('Pushing object to GA. PageLoad - Customer Info.', dataObject);
        } catch (e) {
            console.error('Error pushing customer details on page load. Customer: ' + customerReference);
        }
    }

    function processOrder(orderData) {
        if (!orderData) return;

        var orderReference = void 0;
        try {
            orderReference = orderData.Reference;
            if (pushedOrders.indexOf(orderReference) > -1) {
                if ((pushMode & 2) > 0) console.debug('Order ' + orderReference + ' was already pushed into Google Analytics.');
                return;
            }

            var pushedObject = {
                event: 'order_complete',
                orderId: orderData.Id,
                orderNumber: orderReference,
                customer: customerReference,
                commission: orderData.Commission,
                deliveryType: orderData.DeliveryType,
                paymentType: orderData.Payment_Method,
                priceWithVat: orderData.TotalPriceWithVat,
                value: orderData.TotalPriceWithoutVat,
                quantity: orderData.TransactionProducts.reduce(function (x, y) {
                    return x + y.Quantity;
                }, 0),
                timestampUnixMs: new Date().getTime()
            };
            // push
            if ((pushMode & 1) > 0) window.dataLayer.push(pushedObject);
            // log
            if ((pushMode & 2) > 0) console.debug('Pushing object to GA. Order Finished.', pushedObject);
            // add current order reference to prevent pushing multiple times
            pushedOrders.push(orderReference);
            _storageProvider2.default.setValueSession(pushedOrdersKey, pushedOrders.join('|'));
        } catch (e) {
            console.error('Error processing order ' + orderReference + ' while pushing to google analytics.');
        }
    }
};

var _storageProvider = require('../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/analyticsPusher.js
// module id = 926
// module chunks = 0